<template>
	<div class="amountDispose ">
		<div class="itemTitleBox disBetween">
			<div class="disStart">
				<!-- <span class="title" @click="del22222">充电金额标准配置</span> -->
				<span class="title">充电收费标准</span>
				<!-- <span class="powermanage" @click="powermanage">功率管理</span> -->
				<el-button class="powermanage" type="success" @click="powermanage">功率管理</el-button>
			</div>
			<!-- <div class="icon_add iconBox" @click="openDia" title="新增充电金额配置"></div> -->
		</div>
		<div class="tabBox disStart">
			<el-radio-group v-model="tabPosition">
				<el-radio-button v-for="(item,inx) in tabList" :key="inx"
					:label="inx">{{item.minPower}}~{{item.maxPower}}W</el-radio-button>

			</el-radio-group>
		</div>
		<Container @drop="onDrop" class="listBox " v-if="disposeList && disposeList.length>0" v-loading="loading">
			<Draggable class="itemBox disBetween" v-for="(item,inx) in disposeList" :key="inx">
				<div class="itemLeft boxShaw disBetween" :class="{active:item.rechargeStatus==1}">
					<div class="nameBox">配置{{inx+1}}</div>
					<div class="numBox">
						<div class="numItem disStart">
							<div class="lableBox">充电金额：</div>
							<div class="inputBox">
								<el-input  disabled
									v-model="item.rechargeMoney" type="Number" placeholder=""
									@change="changerechargeTime($event,2,item)"></el-input>
							</div>
							<div class="unitBox">元</div>
						</div>
						<div class="numItem disStart">
							<div class="lableBox">充电时长：</div>
							<div class="inputBox">
								<el-input  v-model="item.rechargeTime"
									 placeholder="" @change="changerechargeTime($event,1,item)"></el-input>
							</div>
							<div class="unitBox">分钟</div>
						</div>
					</div>
				</div>
				<!-- <div class="itemRight ">
					<div class="iconItem disCenter">
						<span class="lockIcon" v-if="item.rechargeStatus==2" @click="btnact(1,item)"></span>
						<span class="unlockIcon" v-if="item.rechargeStatus==1" @click="btnact(2,item)"></span>
					</div>
					<div class="iconItem disCenter">
						<span class="deletIcon" @click="delet(item,inx)"></span>
					</div>
				</div> -->
			</Draggable>
			<div class="addBox icon_add iconBox disStart" v-if="!disposeList && disposeList.length<1" @click="openDia"
				title="新增充电金额配置"><span>+</span>新增充电金额配置</div>
		</Container>
		<!-- <Container @drop="onDrop">
		                <Draggable v-for="item in items" :key="item.id">
		                    <div class="draggable-item">
		                        {{item.data}}
		                    </div>
		                </Draggable>
		            </Container> -->
		<div v-else class="nodataBox">
			<nodata :str="str">
				<template v-slot>
					<div class="slotBox disCenter">
						<div class="disStart" @click="openDia" title="新增充电金额配置">
							<span class="icon_add2"></span>
							<span>新增充电金额配置</span>
						</div>
					</div>
				</template>
			</nodata>
		</div>
		<el-dialog title="功率管理" center class="mydialog" :close-on-click-modal="NOfalse" :visible.sync="dialogVisible"
			width="60%">
			<div class="dialogBox">
				<div class="disStart" v-for="(item,inx) in MytabList" :key="inx">
					<div class="numItem disStart">
						<div class="inputBox">
							<el-input @input="numberChange(item.minPower,1000,inx,1)"  v-model="item.minPower"
								type="Number" placeholder=""></el-input>
						</div>
						<div class="unitBox">~</div>
					</div>
					<div class="numItem disStart">
						<div class="inputBox">
							<el-input @input="numberChange(item.maxPower,1000,inx,2)" 
								v-model="item.maxPower" type="Number" placeholder=""
								@change="changeEnd($event,inx)"></el-input>
						</div>
						<div class="unitBox">W</div>
					</div>
					<div class="btnBox disStart">
						<span class="delIcon" v-if="inx!=0  && inx==MytabList.length-1"
							@click="btnClick(item,inx,1)"></span>
						<span class="addIcon" v-if="inx==MytabList.length-1 && MytabList.length<10 &&newInx<0"
							@click="btnClick(item,inx,2)"></span>
						<span class="yesIcon" v-if="newInx>=0 && inx==MytabList.length-1"
							@click="btnClick(item,inx,3)"></span>
					</div>
				</div>
			</div>
			<div slot="footer" class="dialog-footer diabtnBox disAround">
				<!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
				<el-button type="primary" @click="saveBtn">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	import nodata from "../../../../nodata/nodata.vue"
	import {
		Container,
		Draggable
	} from "vue-smooth-dnd";

	export default {
		name: "amountDispose",
		components: {
			nodata,
			Container,
			Draggable
		},
		props: {

		},
		data() {
			return {
				str: "配置",
				NOfalse: false,
				dialogVisible: false,
				loading: false,
				disposeList: [],
				focusNum: '',
				active: 0,
				tabList: [],
				MytabList: [],
				tabPosition: 0,
				newInx: -1
			}
		},
		watch: {
			tabPosition(n) {
				console.log(this.tabList[n])
				if (this.tabList[n].rechargeBasicSetResModelList && this.tabList[n].rechargeBasicSetResModelList.length >
					0) {
					this.$set(this, "disposeList", this.tabList[n].rechargeBasicSetResModelList)
				} else {
					let obj = {
						rechargeTime: "1",
						rechargeMoney: "1",
						rechargeStatus: "1",
						rechargeBasicPowerSetId: this.tabList[n].rechargeBasicPowerSetId
					}
					this.$set(this, "disposeList", [obj])
					this.$api.addRechargeBasicSet(obj).then((res) => {
						if (res.returnCode == 200) {
							this.getData()
						}
					})
				}
			},
		},
		mounted() {

			this.getData()
		},
		methods: {
			del22222() {
				this.$api.deleteRechargeBasicPowerSet({
					rechargeBasicPowerSetId: this.tabList[0].rechargeBasicPowerSetId
				}).then((res) => {
					if (res.returnCode == 200) {

					}
				})
			},
			changeEnd(e, inx) {
				if (inx <= 9) {
					if (this.MytabList[inx + 1]) {
						this.$set(this.MytabList[inx + 1], "minPower", e)
					}

				}
			},
			numberChange(val, maxNum, n, type) {
				//转换数字类型
				let num = Number(val)
				if (num < 0) {
					if (type == 1) {
						this.$set(this.MytabList[n], "minPower", 0)
					} else {
						this.$set(this.MytabList[n], "maxPower", 0)
					}
				}
				if (num > 2000) {
					if (type == 1) {
						this.$set(this.MytabList[n], "minPower", 2000)
					} else {
						this.$set(this.MytabList[n], "maxPower", 2000)
					}
				}
			},
			powermanage() {
				if (this.tabList.length > 0) {
					this.MytabList = this.tabList
					this.dialogVisible = true
				} else {
					let obj = {
						minPower: 0,
						maxPower: 200,
					}
					this.$api.addRechargeBasicPowerSet(obj).then((res) => {
						if (res.returnCode == 200) {
							this.$set(this, "tabList", [{
								minPower: 0,
								maxPower: 200,
							}])
							this.$set(this, "MytabList", [{
								minPower: 0,
								maxPower: 200,
							}])
							this.dialogVisible = true
						}
					})

				}
			},
			saveBtn() {
				for (let k of this.MytabList) {
					if (k.maxPower) {
						if (Number(k.maxPower) > Number(k.minPower)) {

						} else {
							this.$message({
								type: "warning",
								message: '请输入正确功率范围！'
							});
							return false
						}
					} else {
						this.$message({
							type: "warning",
							message: '请输入正确功率范围！'
						});
						return false
					}
				}
				this.$nextTick(() => {
					this.getData()
					// this.$set(this, "tabList", this.MytabList)
					this.$message({
						type: "success",
						message: '配置成功!'
					});
					this.newInx = -1
					this.dialogVisible = false
				})

			},
			btnClick(item, inx, n) {
				if (n == 1) {

					if (this.MytabList.length == 1) {
						this.$message({
							type: 'warning',
							message: '最少保留一个功率区间!'
						});
						return false
					}
					let that = this
					this.$confirm('是否确认删除该功率区间?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.newInx = -1
						if (item.rechargeBasicPowerSetId) {
							this.$api.deleteRechargeBasicPowerSet({
								rechargeBasicPowerSetId: item.rechargeBasicPowerSetId
							}).then((res) => {
								if (res.returnCode == 200) {

								}
							})
						}
						that.MytabList.splice(inx, 1)
						that.$message({
							type: 'success',
							message: '删除成功!'
						});


					}).catch(() => {

					});
				} else if (n == 2) {
					if (this.MytabList.length == 0) {
						this.MytabList.push({
							minPower: 0,
							maxPower: ''
						})
					} else {
						for (let k of this.MytabList) {
							if (k.maxPower) {
								if (Number(k.maxPower) > Number(k.minPower)) {

								} else {
									this.$message({
										type: "warning",
										message: '请输入正确功率范围！'
									});
									return false
								}
							} else {
								this.$message({
									type: "warning",
									message: '请输入正确功率范围！'
								});
								return false
							}
						}
						this.$nextTick(() => {
							this.newInx = this.MytabList.length
							this.$set(this.MytabList, [this.MytabList.length], {
								minPower: this.MytabList[this.MytabList.length - 1].maxPower,
								maxPower: ""
							})
						})
					}

				} else if (n == 3) {
					if (item.maxPower) {
						if (Number(item.maxPower) > Number(item.minPower) && Number(item.maxPower) <= 2000) {
							console.log(item)
							let obj = {
								minPower: item.minPower,
								maxPower: Number(item.maxPower),
							}
							this.$api.addRechargeBasicPowerSet(obj).then((res) => {
								if (res.returnCode == 200) {
									this.$message({
										type: 'success',
										message: '新增成功!'
									});
									this.newInx = -1
									this.$api.listAllRechargeBasicPowerSet().then((res) => {
										if (res.returnCode == 200) {
											this.$set(this, "MytabList", res.obj)
										}
									})
								}
							})
						} else {
							this.$message({
								type: "warning",
								message: '请输入正确功率范围！'
							});
						}
					} else {
						that.$message({
							type: 'warning',
							message: '请输入功率!'
						});
					}
				}
			},

			handleClick(n) {},
			focusact(e, n) {
				this.focusNum = n
			},
			getData() {
				this.$api.listAllRechargeBasicPowerSet().then((res) => {
					if (res.returnCode == 200) {
						console.log(res.obj)
						for(let k of res.obj){
							for(let j of k.rechargeBasicSetResModelList){
								this.$set(j,"rechargeTime",j.rechargeTime*60)
							}
						}
						this.$set(this, "tabList", res.obj)
						this.$set(this, "disposeList", res.obj[this.tabPosition].rechargeBasicSetResModelList)
						this.$emit("moduleZero", this.tabList)
					}
				})
			},
			changerechargeTime(e, n, item) {
				let obj = {
					rechargeBasicSetId: item.rechargeBasicSetId,
					rechargeTime: parseFloat((item.rechargeTime/60).toFixed(2)), //充电时长
					rechargeMoney: item.rechargeMoney, //充电金额
					rechargeStatus: item.rechargeStatus //禁用状态 1未禁用 2禁用
				}
				if (!(e)) {
					if (n == 1) {
						this.$message({
							type: 'warning',
							message: '充电时长不能为空!'
						});
						this.$set(item, "rechargeTime", this.focusNum)
					} else {
						this.$message({
							type: 'warning',
							message: '充电金额不能为空!'
						});
						this.$set(item, "rechargeMoney", this.focusNum)
					}
					return false
				}
				if(item.rechargeTime%15!=0){
					this.$message({
						type: 'warning',
						message: '请输入15的倍数值!'
					});
				}
				this.$api.updateRechargeBasicSet(obj).then((res) => {
					if (res.returnCode == 200) {
						this.getData()
					}
				}).catch((e) => {
					
				})
			},
			btnact(n, item) {
				let obj = {
					rechargeBasicSetId: item.rechargeBasicSetId,
					rechargeTime: item.rechargeTime, //充电时长
					rechargeMoney: item.rechargeMoney, //充电金额
					rechargeStatus: n //禁用状态 1未禁用 2禁用
				}
				this.$api.updateRechargeBasicSet(obj).then((res) => {
					if (res.returnCode == 200) {
						this.$set(item, "rechargeStatus", n)
						this.getData()
					}
				})
			},
			rechargeMoney(e, item) {},
			onDrop(dropResult) {
				let temp = this.disposeList[dropResult.removedIndex]
				this.disposeList[dropResult.removedIndex] = this.disposeList[dropResult.addedIndex]
				this.$set(this.disposeList, [dropResult.removedIndex], this.disposeList[dropResult.addedIndex])
				this.$set(this.disposeList, [dropResult.addedIndex], temp)
				// this.disposeList[dropResult.addedIndex]=temp
				// this.items = applyDrag(this.items, dropResult);
				// this.$emit("moduleZero", this.disposeList)
			},
			openDia() {
				if (this.tabList.length > 0) {
					let obj = {
						rechargeTime: "1",
						rechargeMoney: "1",
						rechargeStatus: "1",
						rechargeBasicPowerSetId: this.tabList[this.tabPosition].rechargeBasicPowerSetId
					}
					this.$api.addRechargeBasicSet(obj).then((res) => {
						if (res.returnCode == 200) {
							this.getData()
						}
					})
				} else {
					this.$message({
						type: 'warning',
						message: '请先添加充电功率!'
					});
				}


			},
			delet(item, inx) {
				if (this.disposeList.length == 1) {
					this.$message({
						type: 'warning',
						message: '最少保存一个标准配置!'
					});
					return false
				}
				let that = this
				this.$confirm('是否确认删除该配置项?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.deleteRechargeBasicSet({
						rechargeBasicSetId: item.rechargeBasicSetId
					}).then((res) => {
						if (res.returnCode == 200) {
							that.disposeList.splice(inx, 1)
							that.$emit("moduleZero", that.disposeList)
							that.$message({
								type: 'success',
								message: '删除成功!'
							});
						}
					})

				}).catch(() => {

				});

			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "./amountDispose.scss"
</style>